import { styled } from "@mui/material/styles";

import { Tooltip } from "@/shared/components/common/Tooltip";

type Props = {
  backgroundColor?: COLORS;
  children?: React.ReactNode;
  color?: COLORS;
  customClasses?: {
    badge?: string;
    container?: string;
  };
  fontSize?: number;
  text: string;
  tooltipText?: string;
};

const CfTextBadge = ({
  backgroundColor = COLORS.GREY,
  children,
  color = COLORS.WHITE,
  customClasses,
  fontSize,
  text,
  tooltipText = "",
}: Props): React.ReactElement => {
  const badge = (
    <Tooltip title={tooltipText}>
      <Badge
        $absolute={!!children}
        $backgroundColor={backgroundColor}
        $color={color}
        $fontSize={fontSize}
        className={customClasses?.badge}
      >
        <BadgeText>{text}</BadgeText>
      </Badge>
    </Tooltip>
  );

  if (children) {
    return (
      <Container className={customClasses?.container}>
        <BadgeOverlay>{badge}</BadgeOverlay>
        {children}
      </Container>
    );
  }

  return badge;
};

const Container = styled("div")({
  position: "relative",
});

const BadgeOverlay = styled("div")({
  position: "absolute",
  top: 5,
  right: -6,
});

const Badge = styled("div")<{
  $absolute?: boolean;
  $backgroundColor: COLORS;
  $color: COLORS;
  $fontSize?: number;
}>(({ $absolute, $backgroundColor, $color, $fontSize }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 12,
  height: 12,
  backgroundColor: $backgroundColor,
  borderRadius: "50%",
  color: $color,
  fontSize: $fontSize ?? 8.5,
  marginRight: $absolute ? 0 : 8,
}));

const BadgeText = styled("p")({
  margin: 0,
});

export enum COLORS {
  BLUE = "#00ABF4",
  GREY = "#AAAAAA",
  LIGHT_PURPLE = "#CE91D5",
  PURPLE = "#BB0092",
  TRANSPARENT = "#00000000",
  VIOLET = "#534ACE",
  VIOLET_PLUM = "#740D7F",
  WHITE = "#ffffff",
}

export { CfTextBadge };
